import { useEffect } from 'react';

export function useOnUnmount(callback) {
    // Deliberately omit any dependency list to make sure this hook only
    // ever runs once when the component is unmounted.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => () => callback(), []);
}
